import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const parentsSlice = createSlice({
    name: 'parents',
    initialState: {
        items: [],
        item: {},
        procesing: false,
        message: "",
        error: "",
    },
    reducers: {
        initialStateParent: (state, action) => {
            return {
                items: [],
                item: {},
                procesing: false,
                message: "",
                error: "",
            }
        },
        setParents: (state, action) => {
            return {
                items: action.payload,
                item: {},
                procesing: false,
                message: "",
                error: "",
            }
        },
        setProcessParent: (state, action) => {
            return {
                items: [],
                item: {},
                procesing: true,
                message: "",
                error: "",
            }
        },
        setParent: (state, action) => {
            return {
                items: [],
                item: action.payload,
                procesing: false,
                message: "",
                error: "",
            }
        },
        setCreateParent: (state, action) => {
            return {
                items: [],
                item: action.payload.email,
                procesing: false,
                message: action.payload.mesagge,
                error: "",
            }
        },
        setParentMessages: (state, action) => {
            return {
                items: [],
                item: {},
                procesing: false,
                message: action.payload,
                error: "",
            }
        },
        setParentError: (state, action) => {
            return {
                items: [],
                item: {},
                procesing: false,
                message: "",
                error: action.payload,
            }
        },
        requestChangePasswordParent(state, action) {
            return {
                items: [],
                item: {},
                processing: true,
                fetching: false,
                procesing: false,
                message: "",
                error: "",
            }
        },
         changePasswordParentSuccess(state, action) {
            return {
                items: [],
                item: {},
                processing: false,
                fetching: false,
                message: action.payload,
                error: "",
            }
        },
        changePasswordParentError(state, action) {
            return {
                items: [],
                item: {},
                processing: false,
                fetching: false,
                message: "",
                error: action.payload,
            }
        },
        requestForgotPasswordParent(state, action) {
            return {
                items: [],
                item: {},
                processing: true,
                fetching: false,
                procesing: false,
                message: "",
                error: "",
            }
        },
        ForgotPasswordParentSuccess(state, action) {
            return {
                items: [],
                item: {},
                processing: false,
                fetching: false,
                message: action.payload,
                error: "",
            }
        },
        ForgotPasswordParentError(state, action) {
            return {
                items: [],
                item: {},
                processing: false,
                fetching: false,
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getParentsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/parents`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParents(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getParentThunk = (parent_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/parents/${parent_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParent(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getMatriculationProccesThunk = (parent_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/parents/matrciculation_proccess/${parent_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParents(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const activateParentAccountThunk = (parent_id) => dispatch => {
    dispatch(setProcessParent());
    axios.put(`/parents/activate_parent_account/${parent_id}`)
        .then(res => {
            dispatch(setParentMessages(res.data))
        })
        .catch(error => {
            dispatch(setParentError(error.response.data.data))
        })
};

export const signInThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post('/auth/parent/login', data)
        .then(res => {
            dispatch(setParent(res.data))
        })
        .catch(error => {
            dispatch(setParentError(error.response.data))
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const upgradePassword = (parent_id, data) => dispatch => {
    dispatch(requestChangePasswordParent());
    axios.put(`/auth/parent/upgradePassword/${parent_id}`, data)
        .then(res => {
            dispatch(changePasswordParentSuccess(res.data.data))
        })
        .catch(res => {
            dispatch(changePasswordParentError(res.response.data))
        })
};

export const createParentAccount = (parent_id, data) => dispatch => {
    dispatch(setProcessParent());
    axios.put(`/auth/parent/create_account/${parent_id}`, data)
        .then(res => {
            dispatch(setCreateParent(res.data))
        })
        .catch(res => {
            dispatch(setParentError(res.response.data))
        })
};

export const ForgotPasswordParent = (data) => dispatch => {
    dispatch(requestForgotPasswordParent());
    axios.put('/auth/parent/forgotPassword', data)
        .then(res => {
            dispatch(ForgotPasswordParentSuccess(res.data.data))
        })
        .catch(res => {
            dispatch(ForgotPasswordParentError(res.response.data))
        })
};


export const { 
    initialStateParent,
    setProcessParent,
    setCreateParent,
    setParents,
    setParent,
    setParentMessages,
    setParentError,
    requestChangePasswordParent,
    changePasswordParentSuccess,
    changePasswordParentError,
    requestForgotPasswordParent,
    ForgotPasswordParentSuccess,
    ForgotPasswordParentError } = parentsSlice.actions;

export default parentsSlice.reducer;